import React from 'react';

type GenderKind = 'female' | 'male' | 'neutral';

interface GenderPreferenceProps {
  gender: string | null | undefined;
}

export const normalizeGenderPreference = (gender: GenderPreferenceProps['gender']): { kind: GenderKind; label: string } => {
  const value = gender?.trim() || '';
  const normalized = value.toLowerCase();
  if (normalized === 'f' || normalized.includes('female') || normalized.includes('woman')) return { kind: 'female', label: 'Female' };
  if (normalized === 'm' || normalized.includes('male') || normalized.includes('man')) return { kind: 'male', label: 'Male' };
  if (normalized.includes('any') || normalized.includes('either') || normalized.includes('both')) return { kind: 'neutral', label: 'Any gender' };
  return { kind: 'neutral', label: value || 'Not specified' };
};

const GenderPreference: React.FC<GenderPreferenceProps> = ({ gender }) => {
  const preference = normalizeGenderPreference(gender);
  const icon = preference.kind === 'female' ? (
    <svg className="h-5 w-5 text-pink-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true"><circle cx="12" cy="8" r="5" /><path strokeLinecap="round" d="M12 13v8m-3-3h6" /></svg>
  ) : preference.kind === 'male' ? (
    <svg className="h-5 w-5 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true"><circle cx="9" cy="15" r="5" /><path strokeLinecap="round" strokeLinejoin="round" d="m13 11 7-7m0 0h-5m5 0v5" /></svg>
  ) : (
    <svg className="h-5 w-5 text-[#A1AAD9]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true"><circle cx="12" cy="8" r="4" /><path strokeLinecap="round" d="M5 21a7 7 0 0 1 14 0" /></svg>
  );

  return (
    <div className="inline-flex min-w-[116px] max-w-full items-center gap-2 rounded-xl border border-[#A1AAD9]/35 bg-[#FFF5D7] px-3 py-2" aria-label={`Gender: ${preference.label}`}>
      <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-[#A1AAD9]/25">{icon}</span>
      <span className="flex min-w-0 flex-col"><span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-[#5A46AA]">Gender</span><span className="truncate text-sm font-medium text-[#342F43]">{preference.label}</span></span>
    </div>
  );
};

export default GenderPreference;
